import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';

import { DateRangeSelect } from './DateRangeSelect';

import './DateTimeSelect.css';

export default function DateRangeSelectTooltip({
  validDate,
  onAccept,
  selectedDates,
  tooltipPlacement = 'right',
}: {
  validDate: boolean;
  onAccept: (from: Date | undefined, to: Date | undefined) => void;
  selectedDates: { from: Date; to: Date } | undefined;
  tooltipPlacement?: 'right' | 'bottom';
}) {
  const { t } = useTranslation();

  return (
    <Tooltip
      title={t('report.dateSelectorTooltip')}
      placement={tooltipPlacement}
      arrow
      open={!validDate}
      disableHoverListener
      disableFocusListener
      disableTouchListener
      slotProps={{
        tooltip: {
          id: 'date_selector_tooltip',
          sx: {
            backgroundColor: 'info.main',
            [`& .MuiTooltip-arrow`]: {
              color: 'info.main', // this sets the arrow background
            },
          },
        },
        popper: {
          sx: {
            zIndex: '1200',
          },
        },
      }}
    >
      <div className={`report-date-selector ${validDate ? '' : 'highlighted'}`} data-qa-element-id="date_picker">
        <DateRangeSelect setSelectedDates={onAccept} currentValue={selectedDates || { from: null, to: null }} />
      </div>
    </Tooltip>
  );
}
